export enum InputEventMessage {
    KEY_DOWN = "KEY_DOWN",
    KEY_UP = "KEY_UP"
}
